.timeDisplay {
  font-family: 'Open Sans', sans-serif;
  font-size: var(--font\/fontsize\/body-p, 16px);
  font-weight: 400;
  line-height: 1.7;
  color: var(--color\/text\/text-primary, #fff);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
  user-select: none;
}
